<template>
  <div id="app" class="app-shell">
    <site-navigation />
    <main class="app-main">
      <router-view v-slot="{ Component, route }">
        <template v-if="route.meta.keepAlive">
          <keep-alive>
            <component
              :is="Component"
              :key="route.name"
            />
          </keep-alive>
        </template>
        <component
          :is="Component"
          v-else
          :key="route.fullPath"
        />
      </router-view>
    </main>
    <site-footer />
  </div>
</template>

<script>
import SiteNavigation from './components/Nav'
import SiteFooter from './components/Footer'

export default {
  name: 'OfficialWebsiteApp',
  components: {
    SiteNavigation,
    SiteFooter,
  },
}
</script>

<style lang="less">
@import './assets/css/reset.css';
@import './assets/css/common.css';
</style>
